import { type Country } from '@/domain/country/types';
import { Chip } from '@andritzot/metris-web-ui/data-display/chip';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { Fragment } from 'react/jsx-runtime';

interface CountriesContentProps {
  productCountries: Country[];
}

export const CountriesContent = ({ productCountries }: CountriesContentProps) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', m: 2, gap: 2 }}>
      {productCountries?.map((country) => (
        <Fragment key={country.idCountry}>
          <Chip label={country.name} variant="outlined" color="primary" />
        </Fragment>
      ))}
    </Box>
  );
};
